<template>
  <div v-if="post.status != 'No tiene acceso'">
    <div class="breadcrumb">
      <ul>
        <li v-for="(bc,i) in breadcrumbs" :key="i" :class="{'linked': !!bc.link}">
          <router-link tag="li" :to="bc.link">
            <div v-if="i === post.breadcrumbs.length -1">
              <a style="text-decoration: none; color: black; font-weight: bold;">{{bc.name}}</a>
            </div>
            <a v-else style="text-decoration: none; color: black;">{{bc.name}}</a>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- POST -->
    <PostStyleMobile v-if="$vuetify.breakpoint.smAndDown" :post="post"/>
    <Style1 v-else :post="post" />
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import Style1 from "@/components/Posts/Style1";
import PostStyleMobile from "@/components/Posts/PostStyleMobile"
export default {
  components: {
    Style1,
    PostStyleMobile
  },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  methods: {
    // ...mapGetters("posts", ["getSelectedPost"]),
    goToPostsList() {
      this.$router.push({
        name: "posts"
      });
    }
  },
  computed: {
    ...mapState("user", ["current_user"]),
    breadcrumbs() {
      return this.$vuetify.breakpoint.smAndDown ? this.post.breadcrumbs.slice(0, 2) : this.post.breadcrumbs 
    }
  },
  mounted() {
    // Manda el scroll al inicio cada vez que se cambia de ruta
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
.image_post {
  border: 1px solid black;
  padding: 1px;
}
ul {
  display: flex;
  justify-content: left;
  list-style-type: none;
}
ul > li {
  display: flex;
  float: left;
  width: auto;
  color: default;
  font-weight: bold;
  font-size: 1.2em;
  cursor: default;
  align-items: center;
}
ul > li:not(:last-child)::after {
  content: ">";
  float: right;
  font-size: 1.2em;
  margin: 0 0.5em;
  color: light-default;
  cursor: default;
}
.linked {
  cursor: pointer;
  font-size: 1.2em;
  font-weight: normal;
}
</style>
